<template>
  <v-layout class="punchIn-page" pt-4 row wrap justify-center>
    <v-flex xs12>
      <v-toolbar color="transparent" flat dense>
          <img :src="require('@/assets/digitory/Light_Transparent250.png')" alt="DigiPoS-kds" height="48" width="48"
            style="border-radius:0; margin-bottom: 3px;" />
        <v-toolbar-title class="font-title-bold white--text ml-0 mt-1">DigiPoS KDS</v-toolbar-title>
        <v-spacer></v-spacer>
        <span>
          <div class="font-title-bold pr-3 white--text">{{ node }}</div>
        </span>
        <v-btn icon @click="logout()" right>
          <v-icon color="white">flaticon-power-off</v-icon>
        </v-btn>
      </v-toolbar>
    </v-flex>

    <v-flex hidden-sm-and-down md6>
      <!-- <v-card color="transparent" flat text-xs-center>
        <v-img class="rolo-logo" :src="require('@/assets/digitory/Light_Transparent.png')" height="200px"
          width="162px" />
      </v-card> -->
    </v-flex>

    <v-flex class="punchIn-v-app" xs12 sm12 md4 offset-md1>
      <h2 class="text-xs-center white--text">{{ kitchenLine }}</h2>
      <h2 class="text-xs-center white--text">{{ store.name }}</h2>
      <br />
      <v-layout justify-center :class="{ 'animate-shake': inValid }" pb-2>
        <div v-if="pin.length <= 4">
          <span v-for="i in 4" class="punchIn-pin-icon text-truncate" :key="i">
            <v-icon class="lens-elm" v-if="pin.length < i">panorama_fish_eye</v-icon>
            <v-icon class="lens-elm" v-if="pin.length >= i">lens</v-icon>
          </span>
        </div>
        <div v-else>
          <span v-for="i in pin.length" class="punchIn-pin-icon text-truncate" :key="i">
            <v-icon class="lens-elm">lens</v-icon>
          </span>
        </div>
      </v-layout>

      <div class="xs-center punchIn-btn-row" pt-3>
        <v-btn fab large class="punchIn-btn" @click="punch('1')" v-shortkey="['1']" @shortkey="punch('1')">
          <span class="punchIn-btn-text">1</span>
        </v-btn>
        <v-btn fab large class="punchIn-btn" @click="punch('2')" v-shortkey="['2']" @shortkey="punch('2')">
          <span class="punchIn-btn-text">2</span>
        </v-btn>
        <v-btn fab large class="punchIn-btn" @click="punch('3')" v-shortkey="['3']" @shortkey="punch('3')">
          <span class="punchIn-btn-text">3</span>
        </v-btn>
      </div>
      <div class="xs-center punchIn-btn-row" pt-3>
        <v-btn fab large class="punchIn-btn" @click="punch('4')" v-shortkey="['4']" @shortkey="punch('4')">
          <span class="punchIn-btn-text">4</span>
        </v-btn>
        <v-btn fab large class="punchIn-btn" @click="punch('5')" v-shortkey="['5']" @shortkey="punch('5')">
          <span class="punchIn-btn-text">5</span>
        </v-btn>
        <v-btn fab large class="punchIn-btn" @click="punch('6')" v-shortkey="['6']" @shortkey="punch('6')">
          <span class="punchIn-btn-text">6</span>
        </v-btn>
      </div>
      <div class="xs-center punchIn-btn-row" pt-3>
        <v-btn fab large class="punchIn-btn" @click="punch('7')" v-shortkey="['7']" @shortkey="punch('7')">
          <span class="punchIn-btn-text">7</span>
        </v-btn>
        <v-btn fab large class="punchIn-btn" @click="punch('8')" v-shortkey="['8']" @shortkey="punch('8')">
          <span class="punchIn-btn-text">8</span>
        </v-btn>
        <v-btn fab large class="punchIn-btn" @click="punch('9')" v-shortkey="['9']" @shortkey="punch('9')">
          <span class="punchIn-btn-text">9</span>
        </v-btn>
      </div>
      <div class="xs-center punchIn-btn-row" pt-3>
        <v-btn fab large class="punchIn-btn" @click="punchIn('', 'operation')" v-shortkey="['ctrl', 's']"
          @shortkey="punchIn('', 'operation')">
          <v-icon dark class="punchIn-btn-text">flaticon-settings</v-icon>
        </v-btn>
        <v-btn fab large class="punchIn-btn" @click="punch('0')" v-shortkey="['0']" @shortkey="punch('0')">
          <span class="punchIn-btn-text">0</span>
        </v-btn>
        <v-btn fab large class="punchIn-btn" @click="backSpace()" v-shortkey="['backspace']" @shortkey="backSpace()">
          <v-icon dark class="punchIn-btn-text" color="error">flaticon-backspace</v-icon>
        </v-btn>
      </div>
      <div class="xs-center punchIn-btn-row" pt-3>
        <v-btn fab large class="punchIn-btn action" @click="clockIn()" v-shortkey="['shift', 'i']"
          @shortkey="clockIn()">
          <v-icon dark class="punchIn-btn-text">flaticon-clock-in</v-icon>
        </v-btn>
        <v-btn fab large class="punchIn-btn action" @click="clockOut()" v-shortkey="['shift', 'o']"
          @shortkey="clockOut()">
          <v-icon dark class="punchIn-btn-text">flaticon-clock-out</v-icon>
        </v-btn>
        <v-btn fab large class="punchIn-btn action" @click="punchIn()" v-shortkey="['enter']" @shortkey="punchIn()">
          <v-icon dark class="punchIn-btn-text">flaticon-login</v-icon>
        </v-btn>
      </div>
      <role :roles="roles" :enable.sync="enableRole" :action="doAction"></role>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.punchIn-page {
  background-color: #0d7e83;
  background-image: url("./../../assets/pin_bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}

.punchIn-v-app {
  text-align: center;
}

.punchIn-btn-row {
  padding-top: 5px;
}

.punchIn-btn {
  font-size: 30px;
  background-color: inherit !important;
  opacity: 0.7;
  /* mix-blend-mode: screen; */
  /* background-color: black !important; */
}

.punchIn-btn-text {
  margin-top: -4px;
}

.punchIn-pin-icon {
  padding-left: 5px;
}

.rolo-logo {
  margin-left: auto;
  margin-right: auto;
}

.lens-elm {
  color: #FFF;
}

/* light */
.punchIn-btn {
  color: #FFF !important;
  border: 1px solid #FFF;
}

.theme--light .lens-elm {
  color: #FFF;
}
</style>

<script>
import { requestInfo, clearLocalStorage } from "@/providers/RoloProvider";
import role from "@/components/employee/role";
import { globalData } from "@/providers/global";

export default {
  name: "PunchIn",
  components: {
    role,
  },
  mixins:[globalData],
  data() {
    return {
      pin: "",
      inValid: false,
      store: {},
      node: localStorage.getItem("nodeId") || "",
      kitchenLine: JSON.parse(localStorage.getItem("kitchenLine")).name || "",
      enableRole: false,
      roles: [],
      doAction: () => { },
    };
  },
  methods: {
    setInvalid() {
      this.inValid = true;
      setTimeout(() => {
        this.inValid = false;
      }, 500);
    },
    valid() {
      if (this.pin && this.pin.length > 3 && this.pin.length < 11) {
        return true;
      }
      this.setInvalid();
      return false;
    },
    punch(n) {
      this.inValid = false;
      if (this.pin.length > 10) {
        this.setInvalid();
        return;
      }
      this.pin = this.pin + n;
    },
    backSpace() {
      const l = this.pin.length;
      this.pin = this.pin.toString().slice(0, l - 1);
    },
    clearPin() {
      this.pin = "";
    },
    punchIn(roleID, page) {
      if (!this.valid()) return;
      this.$root.$loader.start("Processing punchIn", {});

      let data = {
        ...requestInfo().info,
        store_id: localStorage.getItem("storeId"),
        account_id: localStorage.getItem("accountId"),
        page,
      };
      if (roleID) data.role_id = roleID;
      // console.log("punchin: ", this.$apiURL);
      this.$http
        .put(
          this.$apiURL +
          "store/" +
          this.store.id +
          "/employee/" +
          this.pin +
          "/kds/punchIn",
          data
        )
        .then((resp) => {
          // console.log(resp.body);
          if (resp.status === 203) {
            this.enableRole = true;
            this.roles = resp.body.roles || [];
            this.doAction = this.punchIn;
            return;
          }
          this.$store.commit("setUserPrivileges", resp.body.employee);

          this.$router.push("/kds/home");
        })
        .catch((failure) => {
          // console.log(failure);
          this.handleFailure(failure);
        })
        .finally(() => {
          this.$root.$loader.stop();
        });
    },
    clockIn(roleID) {
      // console.log(this.pin, roleID);
      if (!this.valid()) return;
      this.$root.$loader.start("Processing clockIn", {});

      let data = {
        ...requestInfo().info,
        store_id: localStorage.getItem("storeId"),
        account_id: localStorage.getItem("accountId"),
      };
      if (roleID) data.role_id = roleID;
      this.$http
        .put(
          this.$apiURL +
          "store/" +
          requestInfo().store_id +
          "/employee/" +
          this.pin +
          "/kds/clockIn",
          data
        )
        .then((resp) => {
          console.log("clockin: ", resp.status, resp);
          // if (resp.status === 203) {
          //   this.enableRole = true;
          //   this.roles = resp.body.roles || [];
          //   this.doAction = this.clockIn;
          //   return;
          // }
          // this.pin = "";
          // this.$store.commit("showSnackbar", {
          //   message: resp.body.message,
          //   color: "success",
          // });
        })
        .catch((failure) => {
          this.handleFailure(failure);
        })
        .finally(() => {
          this.$root.$loader.stop();
        });
    },
    clockOut() {
      // console.log(this.pin);
      if (!this.valid()) return;
      this.$root.$loader.start("Processing clockOut", {});

      this.$http
        .put(
          this.$apiURL +
          "store/" +
          requestInfo().store_id +
          "/employee/" +
          this.pin +
          "/kds/clockOut",
          {
            ...requestInfo().info,
            store_id: localStorage.getItem("storeId"),
            account_id: localStorage.getItem("accountId"),
          }
        )
        .then((resp) => {
          // console.log("clockin: ", resp.status, resp);
          this.pin = "";
          this.$store.commit("showSnackbar", {
            message: resp.body.message,
            color: "success",
          });
        })
        .catch((failure) => {
          this.handleFailure(failure);
        })
        .finally(() => {
          this.$root.$loader.stop();
          localStorage.removeItem("privileges");
        });
    },
    logout() {
      this.$root.$confirm
        .open("Confirm", "Are you sure to logout?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$root.$loader.start("Logging out", {});

          let data = {
            ...requestInfo().info,
          };
          this.$http
            .post(
              this.$apiURL + "store/" + requestInfo().store_id + "/logout",
              data
            )
            .then((resp) => {
              // console.log("logout", resp);
              clearLocalStorage();
              this.$router.push({
                path: "/",
              });
            })
            .catch((failure) => {
              this.handleFailure(failure);
            })
            .finally(() => {
              this.$root.$loader.stop();
            });
        });
    },
    handleFailure(failure) {
      // console.log(failure);
      this.setInvalid();
      this.pin = "";
      let msg = failure.body.message || "Error";
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error",
      });
    },
  },
  created() {
    this.store = {
      id: localStorage.getItem("storeId"),
      name: localStorage.getItem("storeName"),
    };
  },
};
</script>

<!-- // .nav-item {
//   color: white !important;
//   border: 1px solid white !important;
//   min-height: 100px;
//   height: 100px;
//   padding: 5px;
//   width: 100%;
//   border-radius: 5px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   /* mix-blend-mode: screen; */
//   opacity: 0.7;
//   cursor: pointer;
// } -->